import type { ChipDesignTokens, ChipTokenSections } from '@openng/optimus-ui-themes/types/chip';

export const colorScheme: ChipTokenSections.ColorScheme = {
	light: {
		root: {
			background: '{primary.50}',
		},
	},
};

export default {
	colorScheme,
} satisfies ChipDesignTokens;
